import { STATIC_URL } from "../constants/conf"
import mapboxgl from "mapbox-gl"
let localhost = STATIC_URL
// localhost = "http://52.83.254.109:8080"
const HEAT_CONF = {
  id: "CAD-heat",
  type: "heatmap",
  source: "CAD",
  paint: {
    "heatmap-weight": {
      property: "mag",
      type: "exponential",
      stops: [[17, 0.1], [21, 0.7]],
    },
    "heatmap-intensity": {
      stops: [[17, 10], [20, 26]],
    },
    "heatmap-color": [
      "interpolate",
      ["linear"],
      ["heatmap-density"],
      0,
      "rgba(33,102,172,0)",
      0.2,
      "rgb(103,169,207)",
      0.4,
      "rgb(209,229,240)",
      0.6,
      "rgb(253,219,199)",
      0.8,
      "rgb(239,138,98)",
      1,
      "rgb(178,24,43)",
    ],
    "heatmap-radius": {
      stops: [[17, 2], [22, 30]],
    },
    "heatmap-opacity": {
      default: 1,
      stops: [[17, 0.9], [21, 0.1]],
    },
  },
}

let heatJsonFormat = function(data) {
  var coords = data.coords
  var features = []
  coords.forEach(function(e) {
    var pXY = e
    var lat = 31 + (51.1611 - (pXY[1] - 15.8462)) * 0.0000089831528411955021 //13.72
    var lon = 121 + (33.1543 + (pXY[0] - 24.6408)) * 0.000010480046116828456 //21.32
    var coordinate
    coordinate = [lon, lat, 1]
    var geometry = {
      type: "Point",
      coordinates: coordinate,
    }
    var feature = {
      type: "Feature",
      properties: {
        mag: 2,
      },
      geometry: geometry,
    }
    features.push(feature)
  })
  var heatjson = {
    type: "FeatureCollection",
    features: features,
  }
  return heatjson
}
export default {
  init: function(features, floor) {
    var chinaStyles = {
      version: 8,
      // sprite: localhost + "/sprite/",
      sprite:
    "https://maps.newayz.com/maps/sprites/aimap/dark-v1/sprite?access_key=5hlKj1icxbxXCoLZ1QwWmO2OyGOjhmCC",
      sources: {},

      // glyphs: localhost + "/fonts/{fontstack}/{range}.pbf",
      glyphs:
      "https://maps.newayz.com/maps/fonts/{fontstack}/{range}.pbf?access_key=5hlKj1icxbxXCoLZ1QwWmO2OyGOjhmCC",
      layers: [
        {
          id: "background",
          type: "background",
          paint: {
            "background-color": "rgb(225,225,225)",
          },
        },
      ],
    }

    var bounds = [[120.99679, 30.99879], [121.005899, 31.002091]]
    var map = new mapboxgl.Map({
      attributionControl: false,
      container: "map",
      center: [121.000899, 31.000291],
      zoom: 18,
      minZoom: 17,
      maxZoom: 20,
      style: chinaStyles,
      doubleClickZoom: false,
      maxBounds: bounds,
      // pitch: 30,
      // pitchWithRotate : false,
      // localIdeographFontFamily: " 'Microsoft YaHei', 'sans-serif'", //
    })

    var nav = new mapboxgl.NavigationControl()
    map.addControl(nav, "top-left")
    // map.addControl(new mapboxgl.ScaleControl({
    //     maxWidth: 80,
    //     unit: 'imperial'
    // }));
    map.on("zoomend", function() {
      console.log(map.getZoom())
    })

    map.on("load", function() {
      map.addSource("points", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: features,
        },
      })

      map.addLayer({
        //底图
        id: "bg",
        type: "fill-extrusion",
        source: "points",
        // "minzoom": 18,
        filter: ["==", "name", "背景"],
        paint: {
          "fill-extrusion-color": {
            property: "color",
            type: "identity",
          },
          "fill-extrusion-height": {
            property: "height",
            type: "identity",
          },
          "fill-extrusion-base": {
            property: "base_height",
            type: "identity",
          },
          "fill-extrusion-opacity": 1,
        },
      })

      // xyToLatlon().then(addHeatmap, errXY);
      // xyAutoToLatlon (1).then (addHeatmap, errXY);

      map.addLayer({
        //三维
        id: "buildings",
        type: "fill-extrusion",
        source: "points",
        // "minzoom": 18,
        filter: [
          "all",
          ["!in", "name", "卫生间", "电梯", "楼梯", "背景"],
          [
            "all",
            ["!in", "name", "卫生间", "电梯", "楼梯", "背景"],
            ["==", "floor", floor],
          ],
        ],
        paint: {
          "fill-extrusion-color": {
            property: "color",
            type: "identity",
          },
          "fill-extrusion-height": {
            property: "height",
            type: "identity",
          },
          "fill-extrusion-base": {
            property: "base_height",
            type: "identity",
          },
          "fill-extrusion-opacity": 1,
        },
      })

      // label and image
      map.addLayer({
        //名称
        id: "name-label",
        type: "symbol",
        source: "points",
        filter: [
          "all",
          ["!in", "name", "卫生间", "电梯", "楼梯", "背景", "柱子"],
          ["==", "floor", floor],
        ],
        layout: {
          // "text-allow-overlap": true,
          "text-field": "{name}",
          "text-size": {
            base: 1,
            stops: [[17, 7], [20, 15]],
          },
          "text-offset": [0, -0.5],
          "text-anchor": "top",
          "text-font": ["Microsoft YaHei Regular"],
        },
        paint: {
          "text-color": "#330000",
          "text-halo-width": 0.1,
          "text-halo-color": "#330000",
        },
      })

      map.addLayer({
        //图标
        id: "icon-label",
        type: "symbol",
        source: "points",
        filter: [
          "all",
          ["in", "name", "卫生间", "电梯", "楼梯"],
          ["==", "floor", floor],
        ],
        layout: {
          "icon-image": "{icon}",
          "icon-size": {
            base: 1,
            stops: [[17, 0.7], [20, 1]],
          },
          "icon-allow-overlap": true,
          "text-font": ["Microsoft YaHei Regular"],
        },
        paint: {},
      })
    })
    return map
  },
  renderMap: function(map, clickedFloor) {
    // console.log(data)
    // map.getSource('points').setData({
    //   "type": "FeatureCollection",
    //   "features": data
    // });
    var museumLayers = ["buildings"]
    museumLayers.forEach(function(layer, i) {
      var currentFilter = map.getFilter(layer)
      var newFilter
      if (currentFilter[2][1].length === 3) {
        // if first time
        newFilter = ["all", currentFilter[2][1], ["==", "floor", clickedFloor]]
      } else {
        // if not first time
        newFilter = ["all", currentFilter[1], ["==", "floor", clickedFloor]]
      }
      map.setFilter(layer, newFilter)
    })

    map.setFilter("icon-label", [
      "all",
      ["in", "name", "卫生间", "电梯", "楼梯"],
      ["==", "floor", clickedFloor],
    ])
    map.setFilter("name-label", [
      "all",
      ["!in", "name", "卫生间", "电梯", "楼梯", "背景", "柱子"],
      ["==", "floor", clickedFloor],
    ])
  },

  renderHeat: function(map, data) {
    // console.log(map, data)
    var heatjson = heatJsonFormat(data) //确定有数据
    if (map.getSource("CAD") && map.getLayer("CAD-heat")) {
      map.getSource("CAD").setData(heatjson)
      return
    }
    if (!map.getSource("CAD")) {
      map.addSource("CAD", {
        type: "geojson",
        data: heatjson,
      })
    }

    if (!map.getLayer("CAD-heat")) {
      map.addLayer(HEAT_CONF)
    }
  },
}
